const r = {
  "cdr-form-error": "cdr-form-error_15-0-1",
  "cdr-form-error__icon": "cdr-form-error__icon_15-0-1"
};
export {
  r as default
};
